import React from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { ToDoListBox } from '../myToDoList/MyToDoList';
import './teamLeadDueTodos.scss';

export const TeamLeadDueTodos = (props:any) => {
    return (
        <div className="todo-notification-content h-100 tl-todos-wrapper">
            {props?.viaPage && props.viaPage === 'ManagerLandingPage' ? (
                    <TabView className='section-header'>
                        <TabPanel header="My To Do's List">
                            <ToDoListBox type="mytodos" />
                        </TabPanel>
                        <TabPanel header="My Team's To Do's List">
                            <ToDoListBox type="myteam" />
                        </TabPanel>
                    </TabView>
                ): (<>
            <div className="todo-column border-end pe-2">
                <div className="section-header px-3 pt-3">My To Do&apos;s List</div>
                <ToDoListBox type="mytodos" />
            </div>
            <div className="notification-column ps-2">
                <div className="section-header px-3 pt-3">My Teams To Do&apos;s List</div>
                <ToDoListBox type="myteam" />
            </div>    </>  
                )}      
        </div>
    );
};
